// import React, { useCallback, useEffect } from 'react';
// import PropTypes from "prop-types";

// //vertical Layout component
// import Header from './Header';
// import Sidebar from './Sidebar';
// import RightSidebar from "../../components/Common/RightSidebar";
// import { withRouter } from 'react-router-dom';

// //redux
// import { useSelector, useDispatch } from "react-redux";

// //actions
// import {
//     changeLayout,
//     changeSidebarTheme,
//     changeSidebarType,
//     changeTopbarTheme,
//     changeLayoutWidth,
//     showRightSidebarAction,
//     changelayoutMode
// } from "../../store/actions";

// const Layout = (props) => {
//     const dispatch = useDispatch();
//     const {
//         breadCrumbItems,
//         layoutWidth,
//         leftSideBarType,
//         topbarTheme,
//         showRightSidebar,
//         leftSideBarTheme,
//         layoutMode
//     } = useSelector((state) => ({
//         breadCrumbItems: state.Breadcrumb.breadCrumbItems,
//         leftSideBarType: state.Layout.leftSideBarType,
//         layoutWidth: state.Layout.layoutWidth,
//         topbarTheme: state.Layout.topbarTheme,
//         showRightSidebar: state.Layout.showRightSidebar,
//         leftSideBarTheme: state.Layout.leftSideBarTheme,
//         layoutMode: state.Layout.layoutMode,
//     }));

//     const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

//     const toggleMenuCallback = () => {
//         if (leftSideBarType === "default") {
//             dispatch(changeSidebarType("condensed", isMobile));
//         } else if (leftSideBarType === "condensed") {
//             dispatch(changeSidebarType("default", isMobile));
//         }
//     };

//     //hides right sidebar on body click
//     const hideRightbar = useCallback((event) => {
//         var rightbar = document.getElementById("right-bar");
//         //if clicked in inside right bar, then do nothing
//         if (rightbar && rightbar.contains(event.target)) {
//             return;
//         } else {
//             //if clicked in outside of rightbar then fire action for hide rightbar
//             dispatch(showRightSidebarAction(false));
//         }
//     }, [dispatch]);

//     /*
//   layout  settings
//   */

//     useEffect(() => {
//         //init body click event fot toggle rightbar
//         document.body.addEventListener("click", hideRightbar, true);
//     }, [hideRightbar]);

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     useEffect(() => {
//         if (layoutMode) {
//             dispatch(changelayoutMode(layoutMode));
//         }
//     }, [leftSideBarTheme, layoutMode, dispatch]);

//     useEffect(() => {
//         dispatch(changeLayout("vertical"));
//     }, [dispatch]);

//     useEffect(() => {
//         if (leftSideBarTheme) {
//             dispatch(changeSidebarTheme(leftSideBarTheme));
//         }
//     }, [leftSideBarTheme, dispatch]);

//     useEffect(() => {
//         if (layoutWidth) {
//             dispatch(changeLayoutWidth(layoutWidth));
//         }
//     }, [layoutWidth, dispatch]);

//     useEffect(() => {
//         if (leftSideBarType) {
//             dispatch(changeSidebarType(leftSideBarType));
//         }
//     }, [leftSideBarType, dispatch]);

//     useEffect(() => {
//         if (topbarTheme) {
//             dispatch(changeTopbarTheme(topbarTheme));
//         }
//     }, [topbarTheme, dispatch]);

//     /*
//     document title
//     */
//     useEffect(() => {
//         const title = props.location.pathname;
//         let currentage = title.charAt(1).toUpperCase() + title.slice(2);

//         document.title =
//             currentage + " | Borex - React Admin & Dashboard Template";
//     }, [props.location.pathname]);

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     return (
//         <React.Fragment>
//             <div id="layout-wrapper">
//                 <Header breadCrumbItems={breadCrumbItems} toggleMenuCallback={toggleMenuCallback} />

//                 <Sidebar
//                     theme={leftSideBarTheme}
//                     type={leftSideBarType}
//                     isMobile={isMobile}
//                 />
//                 <div className="main-content">{props.children}</div>
//             </div>
//             {showRightSidebar ? <RightSidebar /> : null}
//         </React.Fragment>
//     );
// };

// Layout.propTypes = {
//     changeLayoutWidth: PropTypes.func,
//     changeSidebarTheme: PropTypes.func,
//     changeSidebarThemeImage: PropTypes.func,
//     changeSidebarType: PropTypes.func,
//     changeTopbarTheme: PropTypes.func,
//     children: PropTypes.object,
//     isPreloader: PropTypes.any,
//     layoutWidth: PropTypes.any,
//     leftSideBarTheme: PropTypes.any,
//     leftSideBarThemeImage: PropTypes.any,
//     leftSideBarType: PropTypes.any,
//     location: PropTypes.object,
//     showRightSidebar: PropTypes.any,
//     topbarTheme: PropTypes.any,
// };

// export default withRouter(Layout);


import React, { useCallback, useEffect } from 'react';
import PropTypes from "prop-types";

// Vertical Layout component
import Header from './Header';
import Sidebar from './Sidebar';
import RightSidebar from "../../components/Common/RightSidebar";

// Redux
import { useSelector, useDispatch, shallowEqual } from "react-redux";

// Actions
import {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeTopbarTheme,
    changeLayoutWidth,
    showRightSidebarAction,
    changelayoutMode
} from "../../store/actions";

import { useLocation } from 'react-router-dom';
import { useUiStore } from "../../stores/uiStore";
import { documentTitleOf } from "../../constants/app";

const Layout = (props) => {
    const dispatch = useDispatch();
    const location = useLocation(); // Using useLocation hook to access the location
    const pageTitle = useUiStore((s) => s.pageTitle);

    const {
        breadCrumbItems,
        layoutWidth,
        leftSideBarType,
        topbarTheme,
        showRightSidebar,
        leftSideBarTheme,
        layoutMode
    } = useSelector((state) => ({
        breadCrumbItems: state.Breadcrumb.breadCrumbItems,
        leftSideBarType: state.Layout.leftSideBarType,
        layoutWidth: state.Layout.layoutWidth,
        topbarTheme: state.Layout.topbarTheme,
        showRightSidebar: state.Layout.showRightSidebar,
        leftSideBarTheme: state.Layout.leftSideBarTheme,
        layoutMode: state.Layout.layoutMode,
    // 選出來的是每次都新建的物件,不比淺相等的話 store 任何一個角落動一下整個版面就重繪
    }), shallowEqual);

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const toggleMenuCallback = () => {
        if (leftSideBarType === "default") {
            dispatch(changeSidebarType("condensed", isMobile));
        } else if (leftSideBarType === "condensed") {
            dispatch(changeSidebarType("default", isMobile));
        }
    };

    // Hides right sidebar on body click
    const hideRightbar = useCallback((event) => {
        // 右側設定欄沒開就什麼都不做。這支掛在 body 的 **capture** 階段,每一下點擊都先經過它;
        // 模板原本不管開沒開都 dispatch,store 一動 Layout 就重繪,而這個重繪剛好卡在
        // 「瀏覽器已經把 checkbox 勾起來」與「React 的 onChange 還沒跑」之間 ——
        // React 把 checked 寫回舊值,onChange 認定沒變就不觸發,受控勾選框用滑鼠怎麼點都勾不起來
        // (工作項目轉派彈窗整個勾不了;票 37 的 e2e 在真 Chromium 抓到,jest 的合成事件看不出來)。
        if (!showRightSidebar) return;
        var rightbar = document.getElementById("right-bar");
        // If clicked inside right bar, do nothing
        if (rightbar && rightbar.contains(event.target)) {
            return;
        } else {
            // If clicked outside of right bar, hide rightbar
            dispatch(showRightSidebarAction(false));
        }
    }, [dispatch, showRightSidebar]);

    // Layout settings —— callback 換新時要把舊的拆掉,不然 body 上會越掛越多支
    useEffect(() => {
        document.body.addEventListener("click", hideRightbar, true);
        return () => document.body.removeEventListener("click", hideRightbar, true);
    }, [hideRightbar]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (layoutMode) {
            dispatch(changelayoutMode(layoutMode));
        }
    }, [leftSideBarTheme, layoutMode, dispatch]);

    useEffect(() => {
        dispatch(changeLayout("vertical"));
    }, [dispatch]);

    useEffect(() => {
        if (leftSideBarTheme) {
            dispatch(changeSidebarTheme(leftSideBarTheme));
        }
    }, [leftSideBarTheme, dispatch]);

    useEffect(() => {
        if (layoutWidth) {
            dispatch(changeLayoutWidth(layoutWidth));
        }
    }, [layoutWidth, dispatch]);

    useEffect(() => {
        if (leftSideBarType) {
            dispatch(changeSidebarType(leftSideBarType));
        }
    }, [leftSideBarType, dispatch]);

    useEffect(() => {
        if (topbarTheme) {
            dispatch(changeTopbarTheme(topbarTheme));
        }
    }, [topbarTheme, dispatch]);

    // 瀏覽器頁籤 —— 用頁面標題(topbar 同一份),不是 URL path。
    // 模板原本把 pathname 直接當標題,頁籤會長成「Dck/assets/hardware | Borex …」。
    useEffect(() => {
        document.title = documentTitleOf(pageTitle);
    }, [pageTitle, location.pathname]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <React.Fragment>
            <div id="layout-wrapper">
                <Header breadCrumbItems={breadCrumbItems} toggleMenuCallback={toggleMenuCallback} />

                <Sidebar
                    theme={leftSideBarTheme}
                    type={leftSideBarType}
                    isMobile={isMobile}
                />
                <div className="main-content">{props.children}</div>
            </div>
            {showRightSidebar ? <RightSidebar /> : null}
        </React.Fragment>
    );
};

Layout.propTypes = {
    changeLayoutWidth: PropTypes.func,
    changeSidebarTheme: PropTypes.func,
    changeSidebarThemeImage: PropTypes.func,
    changeSidebarType: PropTypes.func,
    changeTopbarTheme: PropTypes.func,
    children: PropTypes.object,
    isPreloader: PropTypes.any,
    layoutWidth: PropTypes.any,
    leftSideBarTheme: PropTypes.any,
    leftSideBarThemeImage: PropTypes.any,
    leftSideBarType: PropTypes.any,
    showRightSidebar: PropTypes.any,
    topbarTheme: PropTypes.any,
};

export default Layout;
